/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { AddressData } from './address';
import { AutoOrderSettingDetail } from './autoOrderSettingDetail';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/partner-paths';

export const PartnerPathApi = {
  findChainEntity: async () => {
    const url = `${pathname}/chain-entity`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSupplierEntity: async () => {
    const url = `${pathname}/entity`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerEntity: async (shouldDisplayCustomerPartner: boolean) => {
    const url = `${pathname}/customer?shouldDisplayCustomerPartner=${shouldDisplayCustomerPartner}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerPathForSyncProduct: async (
    option: FindPartnerPathForSyncProductsType
  ) => {
    let url = `${pathname}/sync-products`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPathToEntity: async (id: string) => {
    const url = `${pathname}/path-to-entity/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPathFromCentralEntityToTargetEntity: async (
    option: FindPathFromCentralEntityToTargetEntityType
  ) => {
    let url = `${pathname}/find-partner-path-target-entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface PartnerPathType {
  id: string;
  address: AddressData;
  chainPosition: number;
  createdAt: string;
  name: string;
  path: string[];
  toEntityID: string;
  fromEntityID: string;
}

export interface FindPartnerPathType extends PartnerPathType {
  autoOrderSettingDetail?: AutoOrderSettingDetail;
  pathName: string;
  targetEntityAddressID: string;
  checkValue?: boolean;
  disabled?: boolean;
  status: number;
}

export type FindPartnerPathForSyncProductsType = {
  entityID?: string;
  role: number;
};

export type FindPathFromCentralEntityToTargetEntityType = {
  targetEntityID?: string;
  partnerID: string;
};
